import React from 'react'
import ReactDOM from 'react-dom'

class KeywordInput extends React.Component{

    constructor(props){
      super(props);
    }

    render(){
      var {keyword, onChange, onClick, isLoading} = this.props;

      return ReactDOM.createPortal(<React.Fragment>
        <div class="torm-title">Want more blog ideas? Let us think of ideas for you.</div>
        <div className="form-block w-form">
          <div className="hero-form-holder">
            <form id="email-form" name="email-form" data-name="Email Form" className="form">
              <input type="text" className="input-2 w-input" name="keyword" data-name="Keyword" placeholder="enter your topic here" id="keyword" value={keyword} onChange={onChange} />
              <input type="submit" value={isLoading ? 'Please wait...' : 'Generate Idea'} data-wait="Please wait..." className="button-blue search w-button" onClick={onClick} />
            </form>
          </div>
          <div className={`hero-form-glow glow-1 ${isLoading ? 'active' : ''}`}></div>
          <div className={`hero-form-glow glow-2 ${isLoading ? 'active' : ''}`}></div>
          <div className={`hero-form-glow glow-3 ${isLoading ? 'active' : ''}`}></div>
          <div className={`hero-form-glow glow-4 ${isLoading ? 'active' : ''}`}></div>
        </div>
        </React.Fragment>, document.getElementById('keyword-input'));
    }

}

export default KeywordInput